module.exports = __webpack_public_path__ + "static/media/circled-play-icon-dark.e153552f.svg";